import React, { useCallback, useState } from 'react';
import { Form, Formik } from 'formik';
import { bool } from 'prop-types';
import { useHistory } from 'react-router-dom';

import { BlockWrap } from '../../atoms';
import { formFields, formNames, initialValues } from './schema';
import { FieldsWrapper } from '../formStyles';
import Input from '../_common/Input';
import { SELECT_OPTIONS, CUSTOM_SELECT_PROPS } from './consts';
import { isDefined } from '../../../utils/helpers';
import { useRegistrationStorage } from '../../../hooks/registration';
import { ONBOARDING_STATUS, ONBOARDING_STATUS_WITH_ROUTES } from '../../../constants/registration';
import { UI_ROUTES } from '../../../constants/routes';
import { validator } from './validator';
import SelectWithOthers from './SelectWithOthers';
import SignUpFooter from '../SignUpPersonalDetailsForm/SignUpFooter';
import useDynamicValidation from '../../../hooks/useDynamicValidation';

const COMPONENTS_MAP = {
  [formNames.paymentProcessors]: SelectWithOthers,
};

const COMPONENTS_PROPS_MAP = {
  [formNames.paymentProcessors]: [],
  [formNames.paymentProcessorsOther]: '',
};

const SignUpPaymentProcessorForm = () => {
  const [registrationSession, setRegistrationSession] = useRegistrationStorage();
  const { push } = useHistory();
  const [showOtherInput, setShowOtherInput] = useState(false);
  const validationObject = useDynamicValidation(validator, showOtherInput);

  const handleSubmit = useCallback(
    (values) => {
      if (registrationSession.COMPANY_DETAILS.acceptingPayments === 'YES') {
        setRegistrationSession({
          ...registrationSession,
          [ONBOARDING_STATUS.companyDetails]: values,
          onboardingStatus: ONBOARDING_STATUS.transactionsAmount,
        });
        push(UI_ROUTES.signUpTransactionsAmount);
      } else {
        setRegistrationSession({
          ...registrationSession,
          [ONBOARDING_STATUS.companyDetails]: values,
          onboardingStatus: ONBOARDING_STATUS.paymentMarkets,
        });
        push(UI_ROUTES.signUpMarkets);
      }
    },
    [setRegistrationSession, registrationSession, push]
  );

  const parsedInitialValues = {
    ...initialValues,
    ...(registrationSession?.[ONBOARDING_STATUS.companyDetails] ?? {}),
  };

  return (
    <BlockWrap margin="37px 0 0">
      <FieldsWrapper>
        <Formik initialValues={parsedInitialValues} validate={validationObject} onSubmit={handleSubmit} validateOnBlur>
          <Form>
            {formFields.map(({ field, type, label, ...rest }, index) => {
              const Component = COMPONENTS_MAP[field] || Input;
              const addCustomMargin = field === formNames.companySize;

              return (
                <Component
                  key={field}
                  name={field}
                  {...(isDefined(SELECT_OPTIONS[field]) && {
                    options: SELECT_OPTIONS[field],
                    ...CUSTOM_SELECT_PROPS,
                  })}
                  type={type}
                  label={label}
                  index={index}
                  {...COMPONENTS_PROPS_MAP[field]}
                  {...rest}
                  {...(addCustomMargin && {
                    errorProps: {
                      margin: '6px 0 14px 0',
                    },
                  })}
                  setShowOtherInput={setShowOtherInput}
                />
              );
            })}

            <SignUpFooter
              primaryButtonText="common.continueText"
              previousRoute={
                registrationSession.COMPANY_DETAILS.acceptingPayments === 'YES'
                  ? ONBOARDING_STATUS_WITH_ROUTES.acceptingPayments
                  : ONBOARDING_STATUS_WITH_ROUTES.paymentProcessor
              }
            />
          </Form>
        </Formik>
      </FieldsWrapper>
    </BlockWrap>
  );
};

SignUpPaymentProcessorForm.propTypes = { loading: bool };

SignUpPaymentProcessorForm.defaultProps = { loading: false };

export default SignUpPaymentProcessorForm;
